import "@/App.css";
import "@/dad.css";
import DadLogo from "@/components/DadLogo";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CompanyProvider } from "@/context/CompanyContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Marketing from "@/pages/Marketing";
import Home from "@/pages/Home";
import Actions from "@/pages/Actions";
import Scan from "@/pages/Scan";
import ScanBulk from "@/pages/ScanBulk";
import Queue from "@/pages/Queue";
import OrganPage from "@/pages/OrganPage";
import AccountingPage from "@/pages/AccountingPage";
import PurchasesPage from "@/pages/PurchasesPage";
import Archive from "@/pages/Archive";
import Dna from "@/pages/Dna";
import HealthPage from "@/pages/HealthPage";
import Censimento from "@/pages/Censimento";
import KlaraIntegration from "@/pages/KlaraIntegration";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
        <div className="text-center">
          <DadLogo className="dad-logo-auth" />
        </div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Home />} />
            <Route path="/actions" element={<Actions />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/scan-bulk" element={<ScanBulk />} />
            <Route path="/queue" element={<Queue />} />
            <Route path="/brain" element={<OrganPage organId="brain" />} />
            <Route path="/finance" element={<OrganPage organId="heart" />} />
            <Route path="/intake" element={<OrganPage organId="eyes_ears" />} />
            <Route path="/accounting" element={<AccountingPage />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/sales" element={<OrganPage organId="breathing" />} />
            <Route path="/purchases" element={<PurchasesPage />} />
            <Route path="/hr" element={<OrganPage organId="muscles" />} />
            <Route path="/contracts" element={<OrganPage organId="skeleton" />} />
            <Route path="/compliance" element={<OrganPage organId="immune" />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/dna" element={<Dna />} />
            <Route path="/health-status" element={<HealthPage />} />
            <Route path="/censimento" element={<Censimento />} />
            <Route path="/integrations/klara" element={<KlaraIntegration />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
      </CompanyProvider>
      <Toaster theme="dark" position="top-center" />
    </AuthProvider>
  );
}

export default App;
